import { Form, DatePicker, Select, Button, Row, Col } from "antd";
import { useEffect } from "react";
import SelectCrewMember from "../SelectCrewMember";
import dayjs from "dayjs";

const FilterPanel = ({ onFilter, zones = [], zoneId, zoneDisabled }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (zoneId && zones.length > 0) {
      form.setFieldsValue({ zoneId });
    }
  }, [zones, zoneId]);

  const handleFinish = (values) => {
    const filters = {
      shiftStatus: values.shiftStatus || null,
      employeeCode: values.employeeCode || null,
      fromDate: values.fromDate ? dayjs(values.fromDate).format("YYYY-MM-DD") : null,
      toDate: values.toDate ? dayjs(values.toDate).format("YYYY-MM-DD") : null,
      zoneId: values.zoneId || null,
    };
    onFilter(filters);
  };

  const handleReset = () => {
    form.setFieldsValue({
      employeeCode: null,
      shiftStatus: null,
      fromDate: null,
      toDate: null,
      zoneId: zoneDisabled ? zoneId : null,
    });
    onFilter({ zoneId: zoneDisabled ? zoneId : null });
  };

  return (
    <Form
      form={form}
      onFinish={handleFinish}
      layout="vertical"
      style={{ margin: "1rem" }}
      initialValues={{
        fromDate: dayjs(),
        toDate: dayjs(),
        zoneId: zoneId || null,
      }}
    >
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item name="zoneId" label="Zone">
            <Select
              placeholder="Select Zone"
              allowClear={!zoneDisabled}
              disabled={zoneDisabled}
              options={zones.map((z) => ({ label: z.name, value: z.id }))}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="employeeCode">
            <SelectCrewMember />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="shiftStatus" label="Shift Status">
            <Select placeholder="Select shift status" allowClear>
              <Select.Option value="COMPLETED">Completed</Select.Option>
              <Select.Option value="IN_PROGRESS">In Progress</Select.Option>
              <Select.Option value="WAITING_FOR_APPROVAL">Need Approval</Select.Option>
              <Select.Option value="ABSENT">Absent</Select.Option>
            </Select>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="fromDate" label="From Date">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="toDate" label="To Date">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        <Col span={24} style={{ textAlign: "right" }}>
          <Button type="primary" htmlType="submit">Apply Filters</Button>
          <Button onClick={handleReset} style={{ marginLeft: 8 }}>Reset</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default FilterPanel;
